!function($, window, document) {
    $(window), $(document), $(document.body);
    "ontouchstart" in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints;
    $(".js-toggle").on("click", (function(e) {
        e.preventDefault(), $("body").toggleClass("header-active"), $(".nav").hasClass("black") && $("body").toggleClass("black-nav");
        let $header_nav = $(".header-nav"), toggle_header = $header_nav.prop("inert");
        $("section").prop("inert", toggle_header), $("footer").prop("inert", toggle_header), 
        $header_nav.prop("inert", !toggle_header);
    })), function setAutoplayLocations() {
        let intervalID;
        function fadeToggle() {
            let toggleTab = $(".js-locations-nav-autoplay").find("li.active").next().find("button");
            toggleTab.length || (toggleTab = $(".js-locations-nav-autoplay").find("li:first-child").find("button")), 
            $(toggleTab).trigger("click");
        }
        function startInterval() {
            intervalID || (intervalID = setInterval(fadeToggle, 2500));
        }
        $(".js-locations-nav-autoplay button").on("click", (function(e) {
            e.preventDefault();
            let target = $(this).data("target");
            $(this).parents(".js-locations-wrapper-autoplay").find("li").removeClass("outgoing"), 
            $(this).parents(".js-locations-wrapper-autoplay").find("li.active").addClass("outgoing"), 
            $(this).parents(".js-locations-wrapper-autoplay").find(`[data-id="${target}"]`).addClass("active").siblings().removeClass("active"), 
            $(this).parent().addClass("active").siblings().removeClass("active"), setTimeout((() => {
                $(this).parents(".js-locations-wrapper-autoplay").find("li").removeClass("outgoing");
            }), 500);
        })), $(".js-locations-nav-autoplay, .js-locations-nav-targets").on("mouseover", (function() {
            !function stopInterval() {
                intervalID && (clearInterval(intervalID), intervalID = null);
            }();
        })), $(".js-locations-nav-autoplay, .js-locations-nav-targets").on("mouseleave", (function() {
            startInterval();
        })), startInterval();
    }(), function setStaticLocations() {
        $(".js-locations-nav .location-btn").on("click", (function(e) {
            e.preventDefault();
            let target = $(this).data("target");
            $(this).parents(".js-locations-wrapper").find("li").removeClass("outgoing"), $(this).parents(".js-locations-wrapper").find("li.active").addClass("outgoing"), 
            $(this).parents(".js-locations-wrapper").find(`[data-id="${target}"]`).addClass("active").siblings().removeClass("active"), 
            $(this).parent().addClass("active").siblings().removeClass("active"), setTimeout((() => {
                $(this).parents(".js-locations-wrapper").find("li").removeClass("outgoing");
            }), 500);
        }));
    }(), $(".js-time").each((function(i, el) {
        let timezone = $(el).data("timezone");
        const workHours = $(el).data("work-hours"), timeStrips = $(el).find(".time-strip");
        function checkTime(i) {
            return "0" === i ? "00" : i < 10 ? i = "0" + i : i;
        }
        $(timeStrips).each((function(i, strip) {
            const numerals = parseFloat(strip.dataset.numerals) + 1;
            for (let i = 0; i < numerals; i++) {
                let span = document.createElement("span");
                span.id = `${strip.id}-${i}`, span.dataset.position = i, span.innerText = i, strip.append(span);
            }
        })), function startTime() {
            const zoneDate = (new Date).toLocaleString("en-US", {
                timeZone: timezone
            }), today = new Date(zoneDate);
            let h = today.getHours(), m = today.getMinutes(), s = today.getSeconds();
            h = checkTime(h), m = checkTime(m), s = checkTime(s);
            const time = `${h}${m}${s}`.split("");
            $(timeStrips).each((function(i, strip) {
                const currentTime = time[i];
                strip.style.top = `-${3 * currentTime}rem`, strip.dataset.time = `${currentTime}`;
                const numbers = $(strip).find("span");
                $(numbers).each((function(i, num) {
                    currentTime === num.dataset.position ? $(num).addClass("selected") : $(num).removeClass("selected");
                }));
            })), function checkWorkHours(hour, minute, workHours, element) {
                const openTime = workHours.open, closeTime = workHours.close, currentTime = 60 * parseInt(hour) + parseInt(minute), openMinutes = 60 * openTime.hour + openTime.minute, closeMinutes = 60 * closeTime.hour + closeTime.minute;
                currentTime >= openMinutes && currentTime < closeMinutes ? element.addClass("available") : element.removeClass("available");
            }(h, m, workHours, $(el)), setTimeout(startTime, 500);
        }();
    })), function initProjectsSlider(slider) {
        (slider = slider || $(".js-slider-projects")).each((function() {
            const $currentSlider = $(this), $sliderInitilizer = $currentSlider.find(".slider__slides");
            0 == $currentSlider.find(".slick-initialized").length && ($sliderInitilizer.slick({
                slidesToShow: 3,
                infinite: !0,
                slidesToScroll: 1,
                arrows: !1,
                autoplay: !0,
                autoplaySpeed: 4e3,
                speed: 700,
                responsive: [ {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                } ]
            }), $sliderInitilizer.on("beforeChange", (function(event, slick, currentSlide, nextSlide) {
                const last_slide = slick.$slides.length - 1;
                0 === currentSlide && nextSlide === last_slide ? $(slick.$slides[currentSlide]).prev().addClass("is-sliding") : currentSlide === last_slide && 0 === nextSlide && $(slick.$slides[currentSlide]).next().addClass("is-sliding");
            })), $sliderInitilizer.on("afterChange", (function(event, slick, currentSlide, nextSlide) {
                slick.$slideTrack.find(".slick-cloned").removeClass("is-sliding");
            })));
        }));
    }(), $(".js-hover-item").on("click", (function(e) {
        e.preventDefault();
        let target = $(this).attr("href");
        $(target).addClass("active");
    })), $(".js-hover-item").on("focusout", (function(e) {
        e.preventDefault();
        let target = $(this).attr("href");
        $(target).removeClass("active");
    })), $(".js-scroll-top").on("click", (function(e) {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    })), $(window).on("load", (function() {
        !function initAos() {
            const $container = $(".fadein-parent"), $itemsUp = $(".fadein-item, .fadein-items > *");
            $container.each((function() {
                const $container = $(this), $containerItems = $container.find($itemsUp);
                let delay = 0;
                $containerItems.each((function() {
                    delay = $(this).attr("data-aos-delay") ? $(this).attr("data-aos-delay") : 0, $(this).attr({
                        "data-aos-delay": delay,
                        "data-aos": "fade-up",
                        "data-aos-easing": "ease-out"
                    }), delay += 80;
                })), $(window).on("scroll resize", (function() {
                    $container.hasClass("aos-animate") && $containerItems.addClass("aos-animate"), window.innerHeight + window.scrollY >= document.body.offsetHeight && $(".aos-init:not(.aos-animate)").addClass("aos-animate"), 
                    $(".aos-init").each((function(index, el) {
                        let itemTop = $(this).offset().top;
                        $(window).scrollTop() + .5 * $(window).innerHeight() > itemTop && $(this).addClass("aos-animate");
                    }));
                })), setTimeout((function() {
                    $container.hasClass("aos-animate") && $containerItems.addClass("aos-animate");
                }), 200);
            })), setTimeout((function() {
                AOS.init({
                    duration: 900,
                    once: !0
                });
            }), 200);
        }();
    }));
}(jQuery, window, document);